/*
  GDP: 商品カード表示アニメーション（hyke.jp 参考）
  product-card[gdp-reveal] が画面に入ったら is-visible を付与する。
  無限スクロール・絞り込みで後から追加されたカードも MutationObserver で拾う。
*/
(function () {
  'use strict';

  var SELECTOR = 'product-card[gdp-reveal]';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function showNow(el) {
    el.classList.add('is-visible');
  }

  if (reduceMotion || !('IntersectionObserver' in window)) {
    var revealAll = function () {
      document.querySelectorAll(SELECTOR).forEach(showNow);
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', revealAll);
    } else {
      revealAll();
    }
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      showNow(entry.target);
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });

  /*
    絞り込み・ページネーション（facet:update）では、新しいカードを挿入したあとに
    一覧の先頭へスムーズスクロールするため、そのままだとスクロール中に通過した
    カードがすべて発火してしまう。挿入直後は監視を保留し、スクロールが止まってから監視を開始する。
  */
  var holdQueue = null;

  function startObserving(el) {
    el.setAttribute('data-gdp-observed', '');
    observer.observe(el);
  }

  function enqueueOrObserve(el) {
    if (holdQueue) {
      holdQueue.push(el);
    } else {
      startObserving(el);
    }
  }

  function observe(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(SELECTOR + ':not(.is-visible):not([data-gdp-observed])').forEach(enqueueOrObserve);
    if (root && root.matches && root.matches(SELECTOR) && !root.hasAttribute('data-gdp-observed')) {
      enqueueOrObserve(root);
    }
  }

  function releaseHold() {
    var queued = holdQueue || [];
    holdQueue = null;
    queued.forEach(function (el) {
      if (!el.hasAttribute('data-gdp-observed')) startObserving(el);
    });
  }

  function waitForScrollSettle() {
    var lastY = window.scrollY;
    var stableTicks = 0;
    var started = Date.now();
    var timer = setInterval(function () {
      var y = window.scrollY;
      stableTicks = (y === lastY) ? stableTicks + 1 : 0;
      lastY = y;
      /* 600ms 以上経過し、かつ 300ms 位置が変わらなければ停止とみなす（上限 4s） */
      if ((Date.now() - started > 600 && stableTicks >= 3) || Date.now() - started > 4000) {
        clearInterval(timer);
        releaseHold();
      }
    }, 100);
  }

  document.addEventListener('facet:update', function () {
    holdQueue = holdQueue || [];
    waitForScrollSettle();
  });

  function init() {
    observe(document);
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) observe(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
